import React, { useRef } from 'react';

/**
 * Vector-only phone frame for RNP screen preview (no embedded screenshots / logos).
 * Screen area stays transparent so stacked gradient + icon in RnpScreenPreview show through.
 * Inset matches prior Preview.svg: translate(10.8151, 9.96582) 177.683×384.742 in 200×404.
 */
const PreviewPhone = ({ className, style }) => {
  const maskIdRef = useRef(null);
  if (!maskIdRef.current) {
    maskIdRef.current = `rnpPreviewPhoneMask_${Math.random().toString(36).slice(2, 11)}`;
  }
  const maskId = maskIdRef.current;

  return (
    <svg
      className={className}
      style={style}
      viewBox="0 0 200 404"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <defs>
        <mask id={maskId} maskUnits="userSpaceOnUse" x="0" y="0" width="200" height="404">
          <rect width="200" height="404" rx="36" fill="white" />
          <rect x="10.8151" y="9.96582" width="177.683" height="384.742" rx="28" fill="black" />
        </mask>
      </defs>
      <rect width="200" height="404" rx="36" fill="#14161d" mask={`url(#${maskId})`} />
      <rect
        x="10.8151"
        y="9.96582"
        width="177.683"
        height="384.742"
        rx="28"
        fill="none"
        stroke="rgba(255,255,255,0.08)"
        strokeWidth="0.75"
      />
    </svg>
  );
};

export default PreviewPhone;
